import { authPost } from "@api";

import {
  SlackAppOAuthRequest,
  SlackAppOAuthResponse,
} from "@pages/settings/types";

export const slackAppOAuth = (
  deploymentId: string,
  code: string,
  state: string
): Promise<SlackAppOAuthResponse> => {
  const url = `/api/agent/deployments/${deploymentId}/slack/oauth/callback`;
  return authPost<SlackAppOAuthRequest, SlackAppOAuthResponse>(url, {
    deployment_id: deploymentId,
    code: code,
    state: state,
  });
};
